import {register} from '../vendor/theme-scripts/theme-sections';
import parallaxImage from '../features/image-parallax';
import popupVideoSection from '../features/popup-video';
import {swatchGridSection} from '../features/swatch';
import {productSliderSection} from '../features/product-slider';

register('custom-content', [parallaxImage, popupVideoSection, swatchGridSection, productSliderSection]);
